//默认主题 群青色
import to2d from '@/assets/img/3d.png'
import to3d from '@/assets/img/2d.png'
import dingwei from '@/assets/img/dingwei.png'
import yypt from '@/assets/img/yypt.png'
import ditu from '@/assets/img/ditu.png'
import person from '@/assets/img/user.png'
import logo from '@/assets/img/logo.png'
import lukuang from '@/assets/img/traOn.png'
import quanping from '@/assets/img/fullscreen.png'
import shengyin from '@/assets/img/shengyin.png'
import xiaoyin from '@/assets/img/xiaoyin.png'
import weixing from '@/assets/img/weixingon.png'
import yanse from '@/assets/img/yanse_shen.png'
const defaultTheme = {
    // map: 'amap://styles/54d3ac2da69ddd30aea70b2c191c6de4',
    map: 'amap://styles/8015939191c19f9d3889fb6066703978',
    color: '#74d9ff',
    to2d: to2d,
    to3d: to3d,
    dingwei: dingwei,
    yypt: yypt,
    ditu: ditu,
    person: person,
    logo: logo,
    lukuang: lukuang,
    quanping: quanping,
    shengyin: shengyin,
    xiaoyin: xiaoyin,
    weixing: weixing,
    yanse: yanse

}
//湖蓝色
import th1_to2d from '@/assets/img/theme1/3d.png'
import th1_to3d from '@/assets/img/theme1/2d.png'
import th1_dingwei from '@/assets/img/theme1/dingwei.png'
import th1_yypt from '@/assets/img/theme1/yypt.png'
import th1_ditu from '@/assets/img/theme1/ditu.png'
import th1_person from '@/assets/img/theme1/geren1.png'
import th1_logo from '@/assets/img/theme1/logo.png'
import th1_lukuang from '@/assets/img/theme1/lukuang.png'
import th1_quanping from '@/assets/img/theme1/quanping.png'
import th1_shengyin from '@/assets/img/theme1/shengyin.png'
import th1_xiaoyin from '@/assets/img/theme1/xiaoyin.png'
import th1_weixing from '@/assets/img/theme1/weixing.png'
import th1_yanse from '@/assets/img/theme1/yanse.png'
const theme1 = {
    map: 'amap://styles/8015939191c19f9d3889fb6066703978',
    color: '#a1f2ee',
    to2d: th1_to2d,
    to3d: th1_to3d,
    dingwei: th1_dingwei,
    yypt: th1_yypt,
    ditu: th1_ditu,
    person: th1_person,
    logo: th1_logo,
    lukuang: th1_lukuang,
    quanping: th1_quanping,
    shengyin: th1_shengyin,
    xiaoyin: th1_xiaoyin,
    weixing: th1_weixing,
    yanse: th1_yanse
}
//主题色数组
const themeArr = [
    defaultTheme,
    theme1
]
export {themeArr};


// WEBPACK FOOTER //
// ./src/assets/js/theme.js